export default __webpack_public_path__ + "f6600b0f9a38ebe82aff5f7b978d330b.webm";